import React, { useRef, useState, useEffect } from "react";
import styled, { css } from "styled-components";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import { useGSAP } from "@gsap/react";
import HeaderNavNew from "../../HeaderFotter/Header/HeaderNew.js";
import Fotter from "../../HeaderFotter/Fotter/Fotter.js";
import BlurryCursor from "../../Dependence/Cursor/cursor.jsx";
import FixedNav from "../../HeaderFotter/FixedNav/Fixednav.js";
// import { effect_gsap, effect_out } from "../../../gsapHelper/effectGsap.js";
import axiosInstance from "../../../axiosInstance.js";
import { useForm } from "react-hook-form";
import { ColorRing } from "react-loader-spinner";
import { ToastContainer, toast } from "react-toastify";
import SlideImg from "../OurActivities/SlideImg.js";
import "react-toastify/dist/ReactToastify.css";

const sizes = {
  desktop: 1024,
  tablet: 768,
  phone: 576,
};

const media = Object.keys(sizes).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (max-width: ${sizes[label] / 16}em) {
      ${css(...args)}
    }
  `;
  return acc;
}, {});

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  line-height: 1.5;
  font-size: 20px;
  font-weight: 500;
  color: #7d7f78;
  font-family: "Poppins", "Poppins Placeholder", sans-serif;
  box-sizing: border-box;
`;

const Section = styled.section`
  padding: 0 50px;
  padding-top: 150px;
  width: 100%;
  /* Đảm bảo padding không thay đổi kích thước của div */
  box-sizing: border-box;

  ${media.desktop`
    padding: 50px 30px; // ví dụ thay đổi padding trên desktop nhỏ
  `}
  ${media.tablet`
    padding: 20px 20px; // thay đổi padding trên tablet
  `}
  ${media.phone`
    padding: 10px 10px; // thay đổi padding trên điện thoại
    padding-top: 100px; // giảm padding bottom trên điện thoại
  `}
`;

const effect = (classname, delay = 0) => {
  gsap.from(classname, {
    opacity: 0,
    y: 20,
    duration: 2,
    ease: "power3.out",
    delay: delay,

    scrollTrigger: {
      trigger: classname,
      start: "top 80%",
      end: "bottom 80%",
      toggleActions: "play none none none",
      scrub: false,
      duration: 2,
    },
  });
};
const HomeNew = () => {
  const [isActive, setIsActive] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [openItems, setOpenItems] = useState({});
  const [isMobile, setIsMobile] = useState(false);
  const [description, setDescription] = useState("Designer");
  const { register: registerForm_notify1, handleSubmit: handleSubmit_notify1 } = useForm();
  const { register: registerForm_notify2, handleSubmit: handleSubmit_notify2 } = useForm();
  const { register: registerForm_contact, handleSubmit: handleSubmit_contact } = useForm();
  

  const descriptionRef = useRef(null);
  const content = useRef();
  const faqRefs = useRef([]);
  const headerRef = useRef(null);
  const hww = useRef(null);
  const Testimonials = useRef(null);
  const Faq = useRef(null);
  const Careers = useRef(null);

  const handleActivation = (active) => {
    setIsActive(active);
  };

  gsap.registerPlugin(useGSAP);

  const handleScroll = (param) => {
    if (param === "header") {
      headerRef.current?.scrollIntoView({ behavior: "smooth" });
    } else if (param === "hww") {
      hww.current?.scrollIntoView({ behavior: "smooth" });
    } else if (param === "Testimonials") {
      Testimonials.current?.scrollIntoView({ behavior: "smooth" });
    } else if (param === "Faq") {
      Faq.current?.scrollIntoView({ behavior: "smooth" });
    } else if (param === "Careers") {
      Careers.current?.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    // Function to check screen size and update state
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768); // 768px là kích thước bắt đầu của 'md' trong Tailwind
    };

    // Initial check
    handleResize();

    // Add event listener
    window.addEventListener("resize", handleResize);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    faqRefs.current.forEach((el, index) => {
      if (el) {
        if (openItems[index]) {
          gsap.to(el, { height: "auto", duration: 0.5, ease: "power2.out" });
        } else {
          gsap.to(el, { height: 0, duration: 0.5, ease: "power2.in" });
        }
      }
    });
  }, [openItems]);

  const toggleItem = (index) => {
    setOpenItems((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  gsap.registerPlugin(ScrollTrigger);

  useEffect(() => {
    // Chắc chắn rằng window và document đều sẵn sàng
    if (typeof window !== "undefined" && typeof document !== "undefined") {
      ScrollTrigger.refresh();
    }
  }, []);

  useEffect(() => {
    const imagesLoaded = document.querySelectorAll("img");
    const totalImages = imagesLoaded.length;
    let imagesLoadedCount = 0;

    imagesLoaded.forEach((image) => {
      if (image.complete) {
        imagesLoadedCount++;
      } else {
        image.onload = () => {
          imagesLoadedCount++;
          if (imagesLoadedCount === totalImages) {
            // Khởi tạo ScrollTrigger sau khi tất cả hình ảnh đã tải xong
            ScrollTrigger.refresh();
          }
        };
      }
    });

    if (imagesLoadedCount === totalImages) {
      ScrollTrigger.refresh();
    }
  }, []);

  useGSAP(
    () => {
      // Phần loadingpage
      gsap.fromTo(
        ".loading-page",
        { opacity: 1 },
        {
          opacity: 0,
          display: "none",
          duration: 1.5,
          delay: 4,
        }
      );

      gsap.fromTo(
        ".name-container",
        {
          y: 50,
          autoAlpha: 0,
        },
        {
          y: 0,
          autoAlpha: 1,
          duration: 2,
          delay: 0.5,
        }
      );

      effect(".effect1");
      effect(".effect2");
      effect(".effect3");
      effect(".effect4");
      effect(".effect5");
      effect(".effect6");
      effect(".effect7");
      effect(".effect8", 0.5);
      effect(".effect9", 1);
      effect(".effect10", 0.3);
      effect(".effect11", 0.6);
      effect(".effect12");
      effect(".effect13", 0.6);
      effect(".effect14");
      effect(".effect15");
      effect(".effect16");
      effect(".effect17");
      effect(".effect18", 0.5);
      effect(".effect19", 1);
      effect(".effect20");
      effect(".effect21");
      effect(".effect22");
      effect(".effect23", 0.5);
      effect(".effect24", 1);
      effect(".effect25");
      effect(".effect251");
      effect(".effect26", 0.5);
      effect(".effect27", 1);
      effect(".effect28");
      effect(".effect29");
      effect(".effect30");
      effect(".effect31");
      effect(".effect32");
      effect(".effect33");
      effect(".effect34", 0.5);
      effect(".effect35");
      effect(".effect36");
      effect(".effect37");
      effect(".effect-slide")
    },
    { scope: content }
  );

  const onSubmit = async (data) => {
    setIsLoading(true);

    try {
      const response = await axiosInstance.post("/send-contact", data);
      if (response.status === 200) {
        // Thoong baso thanh cong o day:
        toast.success("Form submitted successfully!");
      } else {
        toast.error("Form submission failed. Please try again.");
      }
    } catch (error) {
      console.error("Error uploading data:", error);
      toast.error("Form submission failed. Please try again.");
    } finally {
      setIsLoading(false); // Kết thúc loading
    }
  };

  const submitEmail = async (data) => {
    setIsLoading(true);

    try {
      const response = await axiosInstance.post("/notify-email", data);
      
      if (response.status === 200) {
        // Thoong baso thanh cong o day:
        toast.success("Form submitted successfully!");
      } else {
        toast.error("Form submission failed. Please try again.");
      }
    } catch (error) {
      console.error("Error uploading data:", error);
      toast.error("Form submission failed. Please try again.");
    } finally {
      setIsLoading(false); // Kết thúc loading
    }
  };

  const descriptions = {
    Designer:
      "Design printed products such as t-shirts, mugs, bags, etc. Ensure the design matches customer requirements and market trends.",
    Sales:
      "Develop strategies to reach potential customers and increase sales.",
    Developer:
      "Create and maintain web applications, ensuring high performance and responsiveness.",
    Ideas:
      "Brainstorm and conceptualize innovative ideas to improve products, services, and customer experience.",
  };

  const handleButtonClick = (job) => {
    gsap.to(descriptionRef.current, {
      opacity: 0,
      y: 20,
      duration: 0.3,
      onComplete: () => {
        setDescription(job);
        gsap.fromTo(
          descriptionRef.current,
          { opacity: 0, y: 20 },
          { opacity: 1, y: 0, duration: 0.5 }
        );
      },
    });
  };
  // const handleButtonClick = (job) => {
  //   setDescription(descriptions[job]);
  // };

  return (
    <Container className="content bg-[#0d0d0d]" ref={content}>
      <HeaderNavNew onActive={handleActivation} handleScroll={handleScroll} />

      {/* Home */}
      <Section ref={headerRef} className="py-16">
        <div className="container mx-auto">
          <div className="flex flex-col items-center ">
            <div className="mb-8 flex justify-center">
              <h1 className="w-10/12 md:w-full text-center text-4xl font-semibold">
                <span
                  className="text-transparent bg-clip-text 
                  leading-[50px] text-[46px]
                  md:leading-[90px] md:text-[80px] 
                  "
                  style={{
                    backgroundImage:
                      "linear-gradient(5deg, rgb(255, 255, 247) 8.55094%, rgb(114, 114, 103) 107.012%)",
                  }}
                >
                  We Design,
                  <br />
                  the efficient way
                </span>
              </h1>
            </div>
            <div className="mb-8 flex justify-center">
              <h6 className="w-10/12 md:w-6/12 text-center text-lg">
                Innovative design solutions for technology firms and emerging
                businesses weary of the typical aesthetic methodology. Arriving
                shortly.
              </h6>
            </div>
            <div className="w-full flex justify-center items-center">
              <form className="flex w-full max-w-md relative" onSubmit={handleSubmit_notify1(submitEmail)}>
                <div className="form-group ">
                  <input
                    type="email"
                    placeholder="name@email.com"
                    className="w-full outline-none py-[25px] pl-[32px] pr-[169px] rounded-full text-[16px] bg-[#0d0d0d]"
                    style={{
                      boxShadow: "inset 0 0 0 1px rgb(38, 38, 38)",
                    }}
                    {...registerForm_notify1("Email", { required: "Email is require!" })} 
                  />
                </div>
                
                <div className="absolute top-[10px] right-[10px] bottom-[10px]">
                  <input
                    type="submit"
                    className="w-[145px] h-full outline-none px-[26px] rounded-full text-[15px] bg-[#ddff00] text-black"
                    style={{
                      boxShadow: "0px 20px 35px rgba(221, 255, 0, 0.2)",
                    }}
                    value="Get notified"
                  />
                </div>
              </form>
            </div>
          </div>
          <div className={isMobile ? "slider-container" : ""}>
            <div className={isMobile ? "slider slider_mobile" : ""}>
              <div className="relative w-full h-64 flex justify-center items-center mt-8">
                <div
                  className="md:absolute w-[200px] h-[210px] left-0 top-[-240px] pr-5"
                >
                  <img
                    src="https://framerusercontent.com/images/71Lkazp81ZpTwq5E8mgETaQgA8.jpg"
                    alt=""
                    className="w-full h-full object-cover object-center rounded-3xl"
                  />
                </div>

                <div
                  href="#"
                  rel="noopener noreferrer"
                  className="md:absolute w-[266px] h-[300px] left-[10%] -bottom-[100px] pr-5"
                >
                  <img
                    src="https://framerusercontent.com/images/zD5YOAhzOzuOk015DU7X7qNNGI.jpg?scale-down-to=512"
                    alt=""
                    className="w-full h-full object-cover object-center rounded-3xl"
                  />
                  {/* <div className="absolute bottom-2 left-2  text-sm">
                    Thomas Cullen
                  </div> */}
                </div>

                <div
                  href="#"
                  rel="noopener noreferrer"
                  className="md:absolute w-[280px] h-[194px] left-center -bottom-[100px] pr-5"
                >
                  <img
                    src="https://framerusercontent.com/images/lRrPICMkVKTOrJaQQBoCo6ZxxA.jpg?scale-down-to=512"
                    alt=""
                    className="w-full h-full object-cover object-center rounded-3xl"
                  />
                </div>

                <div
                  href="#"
                  rel="noopener noreferrer"
                  className="md:absolute w-[266px] h-[300px] right-[10%] -bottom-[100px] pr-5"
                >
                  <img
                    src="https://framerusercontent.com/images/9TKZna4TfSaouPHKZ1nNGn5s4.jpg"
                    alt=""
                    className="w-full h-full object-cover object-center rounded-3xl"
                  />
                </div>
                <div
                  href="#"
                  rel="noopener noreferrer"
                  className="md:absolute w-[200px] h-[210px] right-0 top-[-240px] pb-5 pr-5"
                >
                  <img
                    src="https://framerusercontent.com/images/Br0m8k72i6obkxvmy0bdrdCw50Y.jpg"
                    alt=""
                    className="w-full h-full object-cover object-center rounded-3xl"
                  />
                </div>
                <div
                  href="#"
                  className="md:absolute w-[200px] h-[210px] left-0 top-[-240px] pr-5"
                >
                  <img
                    src="https://framerusercontent.com/images/71Lkazp81ZpTwq5E8mgETaQgA8.jpg"
                    alt=""
                    className="w-full h-full object-cover object-center rounded-3xl"
                  />
                </div>

                <div
                  href="#"
                  rel="noopener noreferrer"
                  className="md:absolute w-[266px] h-[300px] left-[10%] -bottom-[100px] pr-5"
                >
                  <img
                    src="https://framerusercontent.com/images/zD5YOAhzOzuOk015DU7X7qNNGI.jpg?scale-down-to=512"
                    alt=""
                    className="w-full h-full object-cover object-center rounded-3xl"
                  />
                </div>

                <div
                  href="#"
                  rel="noopener noreferrer"
                  className="md:absolute w-[280px] h-[194px] left-center -bottom-[100px] pr-5"
                >
                  <img
                    src="https://framerusercontent.com/images/lRrPICMkVKTOrJaQQBoCo6ZxxA.jpg?scale-down-to=512"
                    alt=""
                    className="w-full h-full object-cover object-center rounded-3xl"
                  />
                </div>

                <div
                  href="#"
                  rel="noopener noreferrer"
                  className="md:absolute w-[266px] h-[300px] right-[10%] -bottom-[100px] pr-5"
                >
                  <img
                    src="https://framerusercontent.com/images/9TKZna4TfSaouPHKZ1nNGn5s4.jpg"
                    alt=""
                    className="w-full h-full object-cover object-center rounded-3xl"
                  />
                </div>
                <div
                  href="#"
                  rel="noopener noreferrer"
                  className="md:absolute w-[200px] h-[210px] right-0 top-[-240px] pb-5"
                >
                  <img
                    src="https://framerusercontent.com/images/Br0m8k72i6obkxvmy0bdrdCw50Y.jpg"
                    alt=""
                    className="w-full h-full object-cover object-center rounded-3xl"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Section>

      {/* slide logo */}
      <Section>
        <div className="text-center">We selling on the top marketplace</div>
        <div className="slider-container">
          <div className={isMobile ? "slider slider_mobile" : "slider"}>
            <img
              src="/Img/logo/amazon.png"
              className="h-[50px] w-auto"
              alt="Loews Hotels"
            />
            <img
              src="/Img/logo/ebay.png"
              className="h-[50px] w-auto"
              alt="Trader Joe's"
            />
            <img
              src="/Img/logo/Etsy.png"
              className="h-[50px] w-auto"
              alt="Hyatt"
            />
            <img
              src="/Img/logo/intagram.png"
              className="h-[50px] w-auto"
              alt="Marriott Hotels & Resorts"
            />
            {/* lặp lại để tạo hiệu ứng liên tục */}
            <img
              src="/Img/logo/meta.png"
              className="h-[50px] w-auto"
              alt="Loews Hotels"
            />
            <img
              src="/Img/logo/spify.png"
              className="h-[50px] w-auto"
              alt="Trader Joe's"
            />
            <img
              src="/Img/logo/tiktok.png"
              className="h-[50px] w-auto"
              alt="Hyatt"
            />
            <img
              src="/Img/logo/amazon.png"
              className="h-[50px] w-auto"
              alt="Loews Hotels"
            />
            <img
              src="/Img/logo/ebay.png"
              className="h-[50px] w-auto"
              alt="Trader Joe's"
            />
            <img
              src="/Img/logo/Etsy.png"
              className="h-[50px] w-auto"
              alt="Hyatt"
            />
            <img
              src="/Img/logo/intagram.png"
              className="h-[50px] w-auto"
              alt="Marriott Hotels & Resorts"
            />
            {/* lặp lại để tạo hiệu ứng liên tục */}
            <img
              src="/Img/logo/meta.png"
              className="h-[50px] w-auto"
              alt="Loews Hotels"
            />
            <img
              src="/Img/logo/spify.png"
              className="h-[50px] w-auto"
              alt="Trader Joe's"
            />
            <img
              src="/Img/logo/tiktok.png"
              className="h-[50px] w-auto"
              alt="Hyatt"
            />
          </div>
        </div>
      </Section>

      {/* Introduct */}
      <Section>
        <div class="flex flex-col justify-start ">
          <div class="flex items-center justify-center space-y-4 effect1">
            <div class="flex items-center justify-center">
              <div class="flex items-center justify-center gap-2 pb-3">
                <img src="/Img/icon/icon.png" className="w-[22px] h-[22px]" alt=""/>
                <div class="flex flex-col justify-start text-yellow-300">
                  INTRODUCING VISGROUP
                </div>
              </div>
            </div>
          </div>
          <div class="flex justify-center text-center font-normal text-[30px] effect2">
            <h2 class="justify-start items-center max-w-[650px] ">
              <span>At the intersection of innovation and technology, </span>

              <span class="text-gray-200">
                we design superior e-commerce strategies, underpinned by a
                commitment to excellence.{" "}
              </span>

              <span>From our establishment in 2015, </span>
              <span class="text-gray-200">
                we have swiftly and consistently grown across the European and
                American sectors,{" "}
              </span>
              <span>
                strengthening our position as a progressive e-commerce pioneer.{" "}
              </span>
            </h2>
          </div>
        </div>
      </Section>

      {/* What wwe did */}
      <Section>
        <div className="flex flex-col gap-60px items-center text-center">
          {/* header */}
          <section class="flex flex-col effect3">
            <div class="flex justify-center">
              <div>
                <div class="flex items-center">
                  <div class="flex items-center justify-center gap-2">
                    <img
                      src="/Img/icon/icon.png"
                      className="w-[22px] h-[22px]"
                      alt=""
                    />
                    <div class="flex flex-col justify-start flex-shrink-0 opacity-100 text-yellow-300">
                      What We Did
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="flex flex-col justify-start flex-shrink-0 opacity-100 effect4"
              style={{
                transform:
                  "perspective(1200px) translateX(0) translateY(0) scale(1) rotate(0) rotateX(0) rotateY(0) skewX(0) skewY(0)",
              }}
            >
              <h2 class="max-w-[650px]">
                <span
                  className="text-transparent bg-clip-text text-[30px]"
                  style={{
                    backgroundImage:
                      "linear-gradient(2005deg, rgb(255, 255, 247) 8.55094%, rgb(114, 114, 103) 107.012%)",
                  }}
                >
                  We bring millions of products to consumers around the world
                </span>
              </h2>
            </div>
          </section>

          <section
            class="w-10/12 flex gap-5 justify-between pt-10
          flex-col md:flex-row"
          >
            {/* Section Đầu */}
            <div
              class="flex flex-col justify-end gap-5 bg-custom-gradient rounded-3xl p-10 text-white border-solid border-[1px] border-[#262626]
            md:w-4/12 effect5"
            >
              <div class="relative flex flex-col items-center justify-center mb-4 effect6">
                <div class="z-10 w-10/12 bg-[#131313] mt-5 rounded-t-2xl p-4 border-solid border-[1px] border-[#262626]">
                  <h6 class="text-yellow-300 text-lg">Growth</h6>

                  <div class="bg-[#514e4e] flex items-center justify-center">
                    <img src="\Img\Mau\grow.jpg" className="w-full" alt=""/>
                  </div>
                </div>

                <div class="absolute top-2 w-9/12 bg-[#39393985] rounded-t-2xl p-6"></div>
              </div>

              <div className="effect7">
                <h3 class="text-xl text-[#cccccc] text-left font-medium">
                  Effective marketing campaigns
                </h3>
                <h4 class="text-[#7a7a7a] mt-2 text-left">
                  We guarantee our premier goods find the right customers at the
                  apt instant.
                </h4>
              </div>
            </div>

            {/* Section Giữa */}
            <div
              class="flex flex-col justify-end bg-custom-gradient rounded-3xl p-10 text-white border-solid border-[1px] border-[#262626]
            md:w-4/12 effect8"
            >
              <div className="h-full flex flex-col justify-between">
                <img src="\Img\Mau\giua.jpg" alt=""/>

                <div className="flex flex-col justify-end effect10">
                  <h3 class="text-xl text-[#cccccc] text-left font-medium">
                    Variety of High-Quality Products
                  </h3>
                  <h4 class="text-[#7a7a7a] mt-2 text-left w-11/12">
                    We’re ready to meet your evolving needs.
                  </h4>
                </div>
              </div>
            </div>

            {/* Section Cuối */}
            <div
              class="flex flex-col justify-end bg-custom-gradient rounded-3xl p-10 text-white border-solid border-[1px] border-[#262626]
            md:w-4/12 effect9"
            >
              <div className="h-full flex flex-col justify-between">
                <img src="\Img\Mau\end.jpg" alt=""/>

                <div className="flex flex-col justify-end effect11">
                  <h3 class="text-xl text-[#cccccc] text-left font-medium">
                    Ideas & Creative Designs
                  </h3>
                  <h4 class="text-[#7a7a7a] mt-2 text-left">
                    We've got the expertise to make your vision a reality.
                  </h4>
                </div>
              </div>
            </div>
          </section>

          <section
            class="w-10/12 flex justify-between gap-10 pt-10
          flex-col md:flex-row"
          >
            {/* Section Đầu */}
            <div
              class="flex flex-col xl:flex-row justify-end gap-5 bg-custom-gradient rounded-3xl text-white border-solid border-[1px] border-[#262626] effect12
            md:w-6/12"
            >

              {/* Đoạn text */}
              <div className="flex justify-end">
                <img src="\Img\work\a.png" className="block xl:hidden py-5 left-0 w-[250px]" alt=""/>
              </div>
              <div className="p-10">
                <h3 class="text-xl text-[#cccccc] text-left font-medium">
                  Workflow integration
                </h3>
                <h4 class="text-[#7a7a7a] mt-2 text-left">
                  Seamlessly connect all your existing apps.
                </h4>
              </div>
              <img
                src="\Img\work\a.png"
                className="hidden xl:block  w-[250px] h-auto py-5 object-contain"
                alt=""
              />
            </div>

            {/* Section Cuối */}
            <div
              class="flex flex-col xl:flex-row justify-end gap-5 bg-custom-gradient rounded-3xl text-white border-solid border-[1px] border-[#262626] effect13
            md:w-6/12"
            >
              {/* Đoạn text */}
              <div className="relative xl:hidden h-52 py-10 mx-5">
                <div className="absolute left-[150px] w-20 h-20 rounded-full bg-[#343434] p-2">
                  <div className="w-full h-full border-8 border-[#1c1c1c] rounded-full bg-[#343434]"></div>
                </div>

                <div className="absolute left-[100px] w-20 h-20 rounded-full bg-green-400 p-2">
                  <div className="w-full h-full border-8 border-[#1c1c1c] rounded-full bg-[#343434]">
                    <img
                      src="\Img\work\avatar3.avif"
                      className="object-cover w-full h-full rounded-full"
                      alt=""
                    />
                  </div>
                </div>

                <div className="absolute left-[50px] w-20 h-20 rounded-full bg-blue-500 p-2">
                  <div className="w-full h-full border-8 border-[#1c1c1c] rounded-full bg-[#343434]">
                    <img
                      src="\Img\work\avatar2.png"
                      className="object-cover w-full h-full rounded-full"
                      alt=""
                    />
                  </div>
                </div>

                <div className="absolute w-20 h-20 rounded-full bg-purple-500 p-2">
                  <div className="w-full h-full border-8 border-[#1c1c1c] rounded-full bg-[#343434]">
                    <img
                      src="\Img\work\avatar1.avif"
                      className="object-cover w-full h-full rounded-full"
                      alt=""
                    />
                  </div>
                </div>
                
                <div>
                  <img src="Img/work/mouse.png" className="absolute w-7 right-[150px] bottom-12" alt=""/>
                  <div className="absolute right-0 w-5/12 bottom-0 bg-[#df0] px-5 py-2 rounded-tr-3xl rounded-b-3xl text-black">Trâm Phan</div>
                </div>
              </div>

              {/* Content */}
              <div className="p-10 pr-0 xl:w-5/12" >
                <div className="flex flex-col justify-end">
                  <h3 class="text-xl text-[#cccccc] text-left font-medium">
                    Excellent customer support
                  </h3>
                  <h4 class="text-[#7a7a7a] mt-2 text-left w-11/12">
                    Seamlessly connect all your existing apps.
                  </h4>
                </div>
              </div>

              {/* responsive cho destop */}
              <div className="flex items-center w-8/12 hidden xl:block">
                <div className="relative h-52 py-10">
                  <div className="absolute left-[150px] w-28 h-28 xl:w-20 xl:h-20 rounded-full bg-[#343434] p-2">
                    <div className="w-full h-full border-8 border-[#1c1c1c] rounded-full bg-[#343434]"></div>
                  </div>

                  <div className="absolute left-[100px] w-28 h-28 xl:w-20 xl:h-20 rounded-full bg-green-400 p-2">
                    <div className="w-full h-full border-8 border-[#1c1c1c] rounded-full bg-[#343434]">
                      <img
                        src="\Img\work\avatar3.avif"
                        className="object-cover w-full h-full rounded-full "
                        alt=""
                      />
                    </div>
                  </div>

                  <div className="absolute left-[50px] w-28 h-28 xl:w-20 xl:h-20 rounded-full bg-blue-500 p-2">
                    <div className="w-full h-full border-8 border-[#1c1c1c] rounded-full bg-[#343434]">
                      <img
                        src="\Img\work\avatar2.png"
                        className="object-cover w-full h-full rounded-full"
                        alt=""
                      />
                    </div>
                  </div>

                  <div className="absolute w-28 h-28 xl:w-20 xl:h-20 rounded-full bg-purple-500 p-2">
                    <div className="w-full h-full border-8 border-[#1c1c1c] rounded-full bg-[#343434]">
                      <img
                        src="\Img\work\avatar1.avif"
                        className="object-cover w-full h-full rounded-full"
                        alt=""
                      />
                    </div>
                  </div>
                  
                  <div>
                    <img src="Img/work/mouse.png" className="absolute w-[10px] h-[10px] left-[120px] bottom-12 z-20" alt=""/>
                    <div className="absolute left-[120px] bottom-0 bg-[#df0] px-5 py-2 rounded-tr-3xl rounded-b-3xl text-black">Trâm Phan</div>
                  </div>
                </div>
              </div>

            </div>
          </section>

          <section className="hidden md:block effect14">
            <div className="flex gap-5 justify-center pt-10">
              <div class="flex gap-2 items-center text-[#7a7a7a] px-5 py-3 bg-custom-gradient rounded-xl border-solid border-[1px] border-[#262626]">
                <img src="/Img/icon/icon.png" className="w-[22px] h-[22px]" alt=""/>{" "}
                Custom Tshirts
              </div>
              <div class="flex gap-2 items-center text-[#7a7a7a] px-5 py-3 bg-custom-gradient rounded-xl border-solid border-[1px] border-[#262626]">
                <img src="/Img/icon/icon.png" className="w-[22px] h-[22px]" alt=""/>{" "}
                Mugs
              </div>
              <div class="flex gap-2 items-center text-[#7a7a7a] px-5 py-3 bg-custom-gradient rounded-xl border-solid border-[1px] border-[#262626]">
                <img src="/Img/icon/icon.png" className="w-[22px] h-[22px]" alt=""/>{" "}
                Blanket
              </div>
              <div class="flex gap-2 items-center text-[#7a7a7a] px-5 py-3 bg-custom-gradient rounded-xl border-solid border-[1px] border-[#262626]">
                <img src="/Img/icon/icon.png" className="w-[22px] h-[22px]" alt=""/>{" "}
                Tumbler
              </div>
            </div>

            <div className="flex gap-5 justify-center pt-10">
              <div class="flex gap-2 items-center text-[#7a7a7a] px-5 py-3 bg-custom-gradient rounded-xl border-solid border-[1px] border-[#262626]">
                <img src="/Img/icon/icon.png" className="w-[22px] h-[22px]" alt=""/>{" "}
                Canvas
              </div>
              <div class="flex gap-2 items-center text-[#7a7a7a] px-5 py-3 bg-custom-gradient rounded-xl border-solid border-[1px] border-[#262626]">
                <img src="/Img/icon/icon.png" className="w-[22px] h-[22px]" alt=""/>{" "}
                Accessories
              </div>
              <div class="flex gap-2 items-center text-[#7a7a7a] px-5 py-3 bg-custom-gradient rounded-xl border-solid border-[1px] border-[#262626]">
                <img src="/Img/icon/icon.png" className="w-[22px] h-[22px]" alt=""/>{" "}
                Shoes
              </div>
            </div>
          </section>
        </div>
      </Section>

      {/* How we works */}
      <Section ref={hww}>
        <div className="flex flex-col gap-60px items-center text-center">
          {/* Headder */}
          <section class="flex flex-col">
            <div class="flex justify-center effect15">
              <div>
                <div class="flex items-center">
                  <div class="flex items-center justify-center gap-2">
                    <img
                      src="/Img/icon/icon.png"
                      className="w-[22px] h-[22px]"
                      alt=""
                    />
                    <div class="flex flex-col justify-start flex-shrink-0 opacity-100 text-yellow-300">
                      How we works
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="flex flex-col justify-start flex-shrink-0 opacity-100 effect16"
              style={{
                transform:
                  "perspective(1200px) translateX(0) translateY(0) scale(1) rotate(0) rotateX(0) rotateY(0) skewX(0) skewY(0)",
              }}
            >
              <h2 class="max-w-[650px]">
                <span
                  className="text-transparent bg-clip-text text-[30px]"
                  style={{
                    backgroundImage:
                      "linear-gradient(2005deg, rgb(255, 255, 247) 8.55094%, rgb(114, 114, 103) 107.012%)",
                  }}
                >
                  Top–notch designs, delivered at your doorstep.
                </span>
              </h2>
            </div>
          </section>

          <section
            class="w-10/12 flex gap-5 justify-between pt-10
          flex-col md:flex-row"
          >
            {/* Section Đầu */}
            <div class="flex flex-col justify-end gap-5 bg-custom-gradient rounded-3xl p-10 text-white md:w-4/12 border-solid border-[1px] border-[#262626] effect17">
              <div class="relative flex flex-col mb-4">
                <img src="\Img\Mau\e.jpg" className="w-6/12 rounded-2xl" alt=""/>
              </div>

              <div>
                <h3 class="text-xl text-[#cccccc] text-left font-medium">
                  Tell us your vision
                </h3>
                <h4 class="text-[#7a7a7a] mt-2 text-left">
                  Choose a plan and share your design project details with us:
                  we’re here to listen.
                </h4>
              </div>
            </div>

            {/* Section Giữa */}
            <div class="flex flex-col justify-end bg-custom-gradient rounded-3xl p-10 text-white md:w-4/12 border-solid border-[1px] border-[#262626] effect18">
              <div className="h-full flex flex-col justify-between">
                <img src="\Img\Mau\c.jpg" className="w-6/12 rounded-2xl" alt=""/>

                <div className="flex flex-col justify-end">
                  <h3 class="text-xl text-[#cccccc] text-left font-medium">
                    Receive the magic
                  </h3>
                  <h4 class="text-[#7a7a7a] mt-2 text-left w-11/12">
                    Sit back and relax: our expert designers will turn your
                    vision into reality.
                  </h4>
                </div>
              </div>
            </div>

            {/* Section Cuối */}
            <div class="flex flex-col justify-end bg-custom-gradient rounded-3xl p-10 text-white md:w-4/12 border-solid border-[1px] border-[#262626] effect19">
              <div className="h-full flex flex-col justify-between">
                <img src="\Img\Mau\d.jpg" className="w-6/12 rounded-2xl" alt=""/>

                <div className="flex flex-col justify-end">
                  <h3 class="text-xl text-[#cccccc] text-left font-medium">
                    Get ongoing support
                  </h3>
                  <h4 class="text-[#7a7a7a] mt-2 text-left">
                    Your subscription ensures you have continuous access to our
                    design team.
                  </h4>
                </div>
              </div>
            </div>
          </section>
        </div>
      </Section>

      {/* Customer story */}
      <Section ref={Testimonials}>
        <div
          className="flex gap-60px items-center
        flex-col md:flex-row"
        >
          <section
            class="flex flex-col items-center gap-12
          w-10/12 md:w-6/12"
          >
            <div>
              <div class="flex items-center effect20">
                <div class="flex items-center justify-center gap-2">
                  <img src="/Img/icon/icon.png" className="w-[22px] h-[22px]" alt=""/>
                  <div class="flex flex-col justify-start flex-shrink-0 opacity-100 text-yellow-300">
                    Customer story
                  </div>
                </div>
              </div>
            </div>

            <div
              className="text-center md:text-left effect21"
              style={{
                transform:
                  "perspective(1200px) translateX(0) translateY(0) scale(1) rotate(0) rotateX(0) rotateY(0) skewX(0) skewY(0)",
              }}
            >
              <h2 class="max-w-[650px]">
                <span
                  className="text-transparent bg-clip-text text-[30px]"
                  style={{
                    backgroundImage:
                      "linear-gradient(2005deg, rgb(255, 255, 247) 8.55094%, rgb(114, 114, 103) 107.012%)",
                  }}
                >
                  “Our growth no longer necessitates the recruitment and
                  education of additional design professionals”
                </span>
                <a href="/abouts/"><h4>Read the story</h4></a>
              </h2>
            </div>
          </section>

          <section class="md:w-6/12 h-full pt-5 effect22">
            <video
              id="background-video"
              autoPlay
              muted
              loop
              playsInline
              className=" object-cover rounded-3xl"
            >
              <source src="/Video/2.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </section>
        </div>
      </Section>
      
      <div className="effect-slide">
        <SlideImg/>
      </div>

      {/* Social Metrics */}
      <Section className="container mx-auto p-4" id="socialmetrics">
        <div className="flex justify-center">
          <section
            class=" flex gap-5 justify-between pt-10
          flex-col md:flex-row"
          >
            {/* Section Đầu */}
            <div className="md:w-4/12 p-5 effect22">
              <img
                className="inset-0 w-full h-auto object-cover rounded-lg"
                src="https://framerusercontent.com/images/fu4JG66sEBCmTvYU3AAaVBA3dNU.png"
                alt="image1"
              />
              <div className="flex flex-col items-center gap-5 pt-5">
                <h4 class="text-[#7a7a7a] mt-2 text-center">
                  Very nice shirt was able to add all our puppies including the
                  big one
                </h4>
                <img src="/Img/Mau/5s.png" className="w-4/12 h-auto" alt=""/>
                <div>
                  <h4 className="text-center text-[#7a7a7a] ">Henry Arthur</h4>
                  <h4 className="text-center text-gray-300">
                    Head of Engineering, Loom
                  </h4>
                </div>
              </div>
            </div>

            {/* Section Giữa */}
            <div class="md:w-4/12 p-5 effect23">
              <img
                className="inset-0 w-full h-auto object-cover rounded-lg"
                src="https://framerusercontent.com/images/fcFViN936qNgvACpTRfj58zE.png"
                alt=""
              />

              <div className="flex flex-col items-center gap-5 pt-5">
                <h4 class="text-[#7a7a7a] mt-2 text-center">
                  My daughter was so happy and very pleased with this shirt!
                </h4>
                <img src="/Img/Mau/5s.png" className="w-4/12 h-auto" alt=""/>
                <div>
                  <h4 className="text-center text-[#7a7a7a]">Jerome Bell</h4>
                  <h4 className="text-center text-gray-300">
                    Product Analyst, Intercom
                  </h4>
                </div>
              </div>
            </div>

            {/* Section Cuối */}
            <div class="md:w-4/12 p-5 effect24">
              <img
                className="inset-0 w-full h-auto object-cover rounded-lg"
                src="https://framerusercontent.com/images/kqOxIWM8xUDYydG3D6fp1bmUrI.png"
                alt=""
              />

              <div className="flex flex-col items-center gap-5 pt-5">
                <h4 class="text-[#7a7a7a] mt-2 text-center">
                  Absolute love it !! My family loves it too. Eldest daughter
                  now wants one with her pups.
                </h4>
                <img src="/Img/Mau/5s.png" className="w-4/12 h-auto" alt=""/>
                <div>
                  <h4 className="text-center text-[#7a7a7a] ">Eleanor Pena</h4>
                  <h4 className="text-center text-gray-300">
                    Head of Product Design, Abstract
                  </h4>
                </div>
              </div>
            </div>
          </section>
        </div>

        <div className="mt-8 border-t border-gray-700 pt-4 effect251">
          <div
            className="flex justify-around gap-4 text-center
          flex-col md:flex-row"
          >
            <div className="effect25">
              <h6 className="text-white text-[50px]">
                <span className="bg-gradient-to-r from-white bg-clip-text text-transparent">
                  1M+
                </span>
              </h6>
              <h6 className="text-[#7a7a7a]">Happy customers</h6>
            </div>
            <div className="hidden md:block border-r border-gray-700 h-20"></div>
            <div className="effect26">
              <h6 className="text-white text-[50px]">
                <span className="bg-gradient-to-r from-white bg-clip-text text-transparent">
                  5k+
                </span>
              </h6>
              <h6 className="text-[#7a7a7a]">Hours spent on craft</h6>
            </div>
            <div className="hidden md:block border-r border-gray-700 h-20"></div>
            <div className="effect27">
              <h6 className="text-white text-[50px]">
                <span className="bg-gradient-to-r from-white bg-clip-text text-transparent">
                  4.8
                </span>
              </h6>
              <h6 className="text-[#7a7a7a]">Review rate</h6>
            </div>
          </div>
        </div>
      </Section>

      {/* FAQ */}
      <Section ref={Faq}>
        <section id="faq" className="container mx-auto p-4 effect28">
          {/* Heading */}
          <div className="text-center mb-8">
            <div class="flex items-center justify-center gap-2 ">
              <img src="/Img/icon/icon.png" className="w-[22px] h-[22px]" alt=""/>
              <h3 className="text-yellow-400 text-lg ml-2">FAQs</h3>
            </div>
            <span
              className=" text-transparent bg-clip-text text-[36px] w-[630px] text-center effect29"
              style={{
                backgroundImage:
                  "linear-gradient(45deg, rgb(255, 255, 247) 8.55094%, rgb(114, 114, 103) 107.012%)",
              }}
            >
              We’ve got the answers
            </span>
          </div>

          {/* FAQ Item */}
          <div className="flex justify-center effect30">
            <div className="space-y-4 max-w-[770px]">
              {/* FAQ Item 1 */}
              <div
                className={`p-4 rounded-3xl shadow-lg ${
                  openItems[1] ? "bg-[#161616]" : ""
                }`}
              >
                <div
                  className="flex justify-between items-center cursor-pointer"
                  onClick={() => toggleItem(1)}
                >
                  <h1 className="text-gray-300">
                    How does VISGROUP ensure quality?
                  </h1>
                  <div
                    className={`transform ${openItems[1] ? "rotate-45" : ""}`}
                  >
                    <img src="/Img/icon/close.png" className="w-[25px]" alt=""/>
                  </div>
                </div>
                <div
                  ref={(el) => (faqRefs.current[1] = el)}
                  className="mt-4 overflow-hidden"
                  style={{ height: 0 }}
                >
                  <h1>
                  Quality is a priority for us. Our team follows a rigorous process of planning, execution, and review to ensure that every project meets our high standards. We work closely with clients to understand their specific needs and provide solutions that are both innovative and reliable.
                  </h1>
                </div>
              </div>

              {/* FAQ Item 2 */}
              <div
                className={`p-4 rounded-3xl shadow-lg ${
                  openItems[2] ? "bg-[#161616]" : ""
                }`}
              >
                <div
                  className="flex justify-between items-center cursor-pointer"
                  onClick={() => toggleItem(2)}
                >
                  <h1 className="text-gray-300">
                    How does VISGROUP handle project timelines?
                  </h1>
                  <div
                    className={`transform ${openItems[2] ? "rotate-45" : ""}`}
                  >
                    <img src="/Img/icon/close.png" className="w-[25px]" alt=""/>
                  </div>
                </div>
                <div
                  ref={(el) => (faqRefs.current[2] = el)}
                  className="mt-4 overflow-hidden"
                  style={{ height: 0 }}
                >
                  <h1>
                    We understand the importance of timely delivery. Once we assess the project scope, we provide a clear timeline with milestones to ensure that your project is completed efficiently, without compromising on quality.
                  </h1>
                </div>
              </div>

              {/* FAQ Item 3 */}
              <div
                className={`p-4 rounded-3xl shadow-lg ${
                  openItems[3] ? "bg-[#161616]" : ""
                }`}
              >
                <div
                  className="flex justify-between items-center cursor-pointer"
                  onClick={() => toggleItem(3)}
                >
                  <h1 className="text-gray-300">
                    Can I customize your services to fit my specific needs?
                  </h1>
                  <div
                    className={`transform ${openItems[3] ? "rotate-45" : ""}`}
                  >
                    <img src="/Img/icon/close.png" className="w-[25px]" alt=""/>
                  </div>
                </div>
                <div
                  ref={(el) => (faqRefs.current[3] = el)}
                  className="mt-4 overflow-hidden"
                  style={{ height: 0 }}
                >
                  <h1>
                    Absolutely! We believe that one size does not fit all. Our solutions are highly customizable to meet the unique requirements of your business. We work closely with you to create a strategy that aligns with your goals and expectations.
                  </h1>
                </div>
              </div>

              {/* FAQ Item 4 */}
              <div
                className={`p-4 rounded-3xl shadow-lg ${
                  openItems[4] ? "bg-[#161616]" : ""
                }`}
              >
                <div
                  className="flex justify-between items-center cursor-pointer"
                  onClick={() => toggleItem(4)}
                >
                  <h1 className="text-gray-300">
                    How can I get in touch with customer support?
                  </h1>
                  <div
                    className={`transform ${openItems[4] ? "rotate-45" : ""}`}
                  >
                    <img src="/Img/icon/close.png" className="w-[25px]" alt=""/>
                  </div>
                </div>
                <div
                  ref={(el) => (faqRefs.current[4] = el)}
                  className="mt-4 overflow-hidden"
                  style={{ height: 0 }}
                >
                  <h1>
                    For any inquiries or support needs, you can reach us at 
                    <a
                      href="mailto:recruitment@vistudio.co"
                      className="text-blue-400 px-2"
                    >
                       recruitment@vistudio.co 
                    </a>
                     or call us at 
                    <a
                      href="tel:+84 326239515"
                      className="text-blue-400"
                    >
                      +84326239515
                    </a>
                    . Our customer support team is available 
                    8 hours/days of the week to assist you with any questions.
                  </h1>
                </div>
              </div>
            </div>
          </div>

          {/* Contact link */}
          <div className="mt-8 text-center">
            <h1 className="text-gray-300">
              Still have more questions? Contact our{" "}
              <a
                href="mailto:recruitment@vistudio.co"
                target="_blank"
                rel="noopener noreferrer"
                className=" underline"
              >
                help center
              </a>
              .
            </h1>
          </div>
        </section>
      </Section>

      {/* Careers */}
      <Section ref={Careers}>
        <div id="careers" className="container mx-auto p-4">
          {/* Heading */}
          <div className="text-center mb-8">
            <div class="flex items-center justify-center gap-2 effect31">
              <img src="/Img/icon/icon.png" className="w-[22px] h-[22px]" alt=""/>
              <h1 className="text-yellow-400 text-lg ml-2">Careers</h1>
            </div>
            <div className="flex justify-center effect32">
              <span
                className=" text-transparent bg-clip-text w-[630px] text-center
                text-[30px] md:text-[36px]"
                style={{
                  backgroundImage:
                    "linear-gradient(45deg, rgb(255, 255, 247) 8.55094%, rgb(114, 114, 103) 107.012%)",
                }}
              >
                We actively search for talented individuals to join our team and
                build amazing things.
              </span>
            </div>
          </div>

          {/* Job Positions */}
          <section
            className="flex gap-10 justify-center
          flex-col md:flex-row"
          >
            <div
              className="flex flex-col gap-4 
            w-full md:w-[500px] effect33"
            >
              <img src="/Img/HomePage/firts_vis.jpg" className="rounded-3xl" alt=""/>
              <div className="flex gap-5 p-4 rounded-lg shadow-lg">
                <div className="flex flex-col w-6/12 gap-5 ">
                  <button
                    class={`relative overflow-hidden bg-[#161616] flex items-center justify-center gap-2 p-3 rounded-xl
                    hover:text-green-300 hover:bg-[#759a76] hover:delay-1000 hover:shadow-green
                    group ${
                      description === "Designer"
                        ? "text-green-300 bg-[#759a76] shadow-green"
                        : ""
                    }`}
                    onClick={() => handleButtonClick("Designer")}
                  >
                    <span
                      className="absolute top-0 -left-full w-full h-[2px] bg-gradient-to-r from-transparent to-[#759a76]
                      group-hover:left-full duration-1000"
                    ></span>
                    <span
                      className="absolute -top-full right-0 w-[2px] h-full bg-gradient-to-b from-transparent to-[#759a76]
                     group-hover:top-full group-hover:delay-[0.25s] duration-1000"
                    ></span>
                    <span
                      className="absolute bottom-0 -right-full w-full h-[2px] bg-gradient-to-l from-transparent to-[#759a76]
                      group-hover:right-full group-hover:delay-500 duration-1000"
                    ></span>
                    <span
                      className="absolute -bottom-full left-0 w-[2px] h-full bg-gradient-to-t from-transparent to-[#759a76]
                      group-hover:bottom-full group-hover:delay-[0.75s] duration-1000"
                    ></span>
                    <img
                      src="/Img/icon/icon.png"
                      className="w-[22px] h-[22px]"
                      alt=""
                    />
                    <h1 className=" ml-2">Designer</h1>
                  </button>
                  <button
                    class={`relative overflow-hidden bg-[#161616] flex items-center justify-center gap-2 p-3 rounded-xl
                    hover:text-green-300 hover:bg-[#759a76] hover:delay-1000 hover:shadow-green
                    group ${
                      description === "Developer"
                        ? "text-green-300 bg-[#759a76] shadow-green"
                        : ""
                    }`}
                    onClick={() => handleButtonClick("Developer")}
                  >
                    <span
                      className="absolute top-0 -left-full w-full h-[2px] bg-gradient-to-r from-transparent to-[#759a76]
                      group-hover:left-full duration-1000"
                    ></span>
                    <span
                      className="absolute -top-full right-0 w-[2px] h-full bg-gradient-to-b from-transparent to-[#759a76]
                     group-hover:top-full group-hover:delay-[0.25s] duration-1000"
                    ></span>
                    <span
                      className="absolute bottom-0 -right-full w-full h-[2px] bg-gradient-to-l from-transparent to-[#759a76]
                      group-hover:right-full group-hover:delay-500 duration-1000"
                    ></span>
                    <span
                      className="absolute -bottom-full left-0 w-[2px] h-full bg-gradient-to-t from-transparent to-[#759a76]
                      group-hover:bottom-full group-hover:delay-[0.75s] duration-1000"
                    ></span>
                    <img
                      src="/Img/icon/icon.png"
                      className="w-[22px] h-[22px]"
                      alt=""
                    />
                    <h1 className=" ml-2">Developer</h1>
                  </button>
                </div>
                <div className="flex flex-col w-6/12 gap-5">
                  <button
                    class={`relative overflow-hidden bg-[#161616] flex items-center justify-center gap-2 p-3 rounded-xl
                      hover:text-green-300 hover:bg-[#759a76] hover:delay-1000 hover:shadow-green
                      group ${
                        description === "Sales"
                          ? "text-green-300 bg-[#759a76] shadow-green"
                          : ""
                      }`}
                    onClick={() => handleButtonClick("Sales")}
                  >
                    <span
                      className="absolute top-0 -left-full w-full h-[2px] bg-gradient-to-r from-transparent to-[#759a76]
                      group-hover:left-full duration-1000"
                    ></span>
                    <span
                      className="absolute -top-full right-0 w-[2px] h-full bg-gradient-to-b from-transparent to-[#759a76]
                     group-hover:top-full group-hover:delay-[0.25s] duration-1000"
                    ></span>
                    <span
                      className="absolute bottom-0 -right-full w-full h-[2px] bg-gradient-to-l from-transparent to-[#759a76]
                      group-hover:right-full group-hover:delay-500 duration-1000"
                    ></span>
                    <span
                      className="absolute -bottom-full left-0 w-[2px] h-full bg-gradient-to-t from-transparent to-[#759a76]
                      group-hover:bottom-full group-hover:delay-[0.75s] duration-1000"
                    ></span>
                    <img
                      src="/Img/icon/icon.png"
                      className="w-[22px] h-[22px]"
                      alt=""
                    />
                    <h1 className=" ml-2">Sales</h1>
                  </button>
                  <button
                    class={`relative overflow-hidden bg-[#161616] flex items-center justify-center gap-2 p-3 rounded-xl
                      hover:text-green-300 hover:bg-[#759a76] hover:delay-1000 hover:shadow-green
                      group ${
                        description === "Ideas"
                          ? "text-green-300 bg-[#759a76] shadow-green"
                          : ""
                      }`}
                    onClick={() => handleButtonClick("Ideas")}
                  >
                    <span
                      className="absolute top-0 -left-full w-full h-[2px] bg-gradient-to-r from-transparent to-[#759a76]
                      group-hover:left-full duration-1000"
                    ></span>
                    <span
                      className="absolute -top-full right-0 w-[2px] h-full bg-gradient-to-b from-transparent to-[#759a76]
                     group-hover:top-full group-hover:delay-[0.25s] duration-1000"
                    ></span>
                    <span
                      className="absolute bottom-0 -right-full w-full h-[2px] bg-gradient-to-l from-transparent to-[#759a76]
                      group-hover:right-full group-hover:delay-500 duration-1000"
                    ></span>
                    <span
                      className="absolute -bottom-full left-0 w-[2px] h-full bg-gradient-to-t from-transparent to-[#759a76]
                      group-hover:bottom-full group-hover:delay-[0.75s] duration-1000"
                    ></span>
                    <img
                      src="/Img/icon/icon.png"
                      className="w-[22px] h-[22px]"
                      alt=""
                    />
                    <h1 className=" ml-2">Ideas</h1>
                  </button>
                </div>
              </div>
              <h1 className="mt-2">
                <div ref={descriptionRef}>
                  <p>{descriptions[description]}</p>
                </div>
              </h1>
              {/* <h1 className="mt-2">
                Sales:
                Develop strategies to reach potential customers and increase
                sales.
              </h1> */}
              {/* Developer
              <h1 className="mt-2">
                Create and maintain web applications, ensuring high performance
                and responsiveness.
              </h1> */}
            </div>

            {/* Job Application Form */}
            <div
              className="p-12 bg-[#161616] rounded-3xl shadow-lg effect34
            w-full md:w-[500px] text-[14px] md:text-lg"
            >
              <form onSubmit={handleSubmit_contact(onSubmit)}>
                <div className="mb-4">
                  <label className="block text-sm font-bold mb-2">Name</label>
                  <input
                    type="text"
                    name="Name"
                    placeholder="Bui Xuan Huan"
                    className="w-full p-2 border-[1px] border-[#262626] rounded-xl bg-[#161616] outline-none"
                    {...registerForm_contact("Name")}
                    required
                  />
                </div>
                <div className="mb-4">
                  <label className="block text-sm font-bold mb-2">
                    Phone Number
                  </label>
                  <input
                    type="tel"
                    name="Phone Number"
                    placeholder="+84999000121"
                    className="w-full p-2 border-[1px] border-[#262626] rounded-xl bg-[#161616] outline-none"
                    {...registerForm_contact("Phone_Number")}
                    required
                  />
                </div>
                <div className="mb-4">
                  <label className="block  text-sm font-bold mb-2">
                    Email*
                  </label>
                  <input
                    type="email"
                    name="Email"
                    placeholder="jane@visgroup.co"
                    className="w-full p-2 border-[1px] border-[#262626] rounded-xl bg-[#161616] outline-none"
                    {...registerForm_contact("Email")}
                    required
                  />
                </div>
                <div className="mb-4">
                  <label className="block  text-sm font-bold mb-2">
                    Position*
                  </label>
                  <select
                    name="Position"
                    className="w-full p-2 border-[1px] border-[#262626] rounded-xl bg-[#161616] outline-none"
                    {...registerForm_contact("Position")}
                    required
                  >
                    <option value="" disabled selected>
                      Select…
                    </option>
                    <option value="Designer">Designer</option>
                    <option value="Sales">Sales</option>
                    <option value="Developer">Developer</option>
                  </select>
                </div>
                <div className="mb-4">
                  <label className="block  text-sm font-bold mb-2">
                    Cover Letter
                  </label>
                  <textarea
                    name="Cover Letter"
                    placeholder="I want to apply this position..."
                    className="w-full p-2 border-[1px] border-[#262626] rounded-xl bg-[#161616] outline-none"
                    {...registerForm_contact("Des")}
                  ></textarea>
                </div>
                <div className="mb-4">
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      name="Newsletter"
                      className="mr-2 leading-tight"
                      required
                    />
                    <span className="">
                      Are you sure confirm your information
                    </span>
                  </label>
                </div>
                <button
                  type="submit"
                  className="w-full bg-[#ddff00] hover:bg-yellow-600 text-black font-bold py-2 px-4 rounded-full transition duration-300"
                >
                  Confirm
                </button>
              </form>
            </div>
          </section>
        </div>
      </Section>

      <Section>
        <section className="py-16 mx-2 rounded-3xl bg-gradient-to-br from-[#161616] to-parents">
          <div className="container mx-auto px-4">
            <div className="text-center p-3 m-5">
              <div className="mb-8 effect35">
                <span
                  className="text-transparent bg-clip-text text-[36px] font-semibold md:leading-[90px]"
                  style={{
                    backgroundImage:
                      "linear-gradient(5deg, rgb(255, 255, 247) 8.55094%, rgb(114, 114, 103) 107.012%)",
                  }}
                >
                  Elevate the way you source design
                </span>
              </div>
              <div className="flex justify-center mb-8 effect36">
                <h1
                  className="font-[500] w-[700px]
                text-[20px] md:text-lg"
                >
                  Get ready to start producing stunning, efficient design work
                  without the hassles of hiring. Soon available.
                </h1>
              </div>
              <div className="w-full flex justify-center items-center effect37">
                <form className="flex w-full max-w-md relative" onSubmit={handleSubmit_notify2(submitEmail)}>
                  <div className="form-group ">
                    <input
                      type="email"
                      placeholder="name@email.com"
                      className="w-full outline-none py-[25px] pl-[32px] pr-[169px] rounded-full text-[16px] bg-[#0d0d0d]"
                      style={{
                        boxShadow: "inset 0 0 0 1px rgb(38, 38, 38)",
                      }}
                      {...registerForm_notify2("Email", { required: "Email is require!" })} 
                    />
                  </div>
                  <div className="absolute top-[15px] right-3">
                    <input
                      type="submit"
                      className="cursor-pointer text-[15px] p-4 rounded-3xl font-semibold bg-[#ddff00] text-black leading-4
                      w-full md:w-[145px]"
                      style={{
                        boxShadow: "0px 20px 35px rgba(221, 255, 0, 0.2)",
                      }}
                      value="Get notified"
                    />
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      </Section>

      <Fotter/>
      <FixedNav />
      <BlurryCursor isActive={isActive} />

      <ToastContainer />
      {isLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgb(75 81 99 / 80%)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <ColorRing
            height={70}
            width={70}
            color="#4fa94d"
            ariaLabel="loading-indicator"
          />
        </div>
      )}
      <div className="scrollElement">
        <div className="loading-page">
          <svg id="logo_svg" width="238" height="335" version="1.1" viewBox="0 0 1600 1600"
            xmlns="http://www.w3.org/2000/svg">
            <path transform="translate(1389,289)"
              d="m0 0c0.99 0.33 1.98 0.66 3 1 0.0934 28.5 0.164 57.1 0.207 85.6 0.0206 13.3 0.0487 26.5 0.0945 39.8 0.0399 11.6 0.0657 23.1 0.0746 34.7 0.00521 6.12 0.0175 12.2 0.0466 18.4 0.0272 5.76 0.0355 11.5 0.0295 17.3 0.0011 2.11 0.00905 4.22 0.0244 6.34 0.0199 2.89 0.0151 5.77 0.0042 8.66 0.0175 1.25 0.0175 1.25 0.0353 2.52-0.0743 7.3-2.67 13-7.36 18.6-0.517 0.624-1.03 1.25-1.57 1.89-0.544 0.642-1.09 1.28-1.65 1.94-1.17 1.4-2.33 2.81-3.5 4.21-0.58 0.697-1.16 1.39-1.76 2.11-2.49 3.03-4.9 6.13-7.31 9.23-3.96 5.09-8.06 10-12.3 14.9-3.74 4.39-7.31 8.9-10.9 13.5-5.11 6.55-10.4 13-15.6 19.4-2.72 3.34-5.44 6.69-8.16 10-1.08 1.33-2.17 2.67-3.25 4-0.536 0.66-1.07 1.32-1.62 2-17.9 22-17.9 22-19.5 24-1.08 1.33-2.16 2.66-3.25 4-2.73 3.36-5.46 6.72-8.2 10.1-5.16 6.33-10.3 12.7-15.3 19.1-3.96 5.08-8.06 10-12.3 14.9-3.31 3.89-6.49 7.86-9.62 11.9-3.57 4.59-7.22 9.08-11 13.5-4.21 4.92-8.25 9.94-12.2 15.1-7.79 9.99-15.9 19.7-23.9 29.6-7.53 9.21-15 18.4-22.3 27.8-3.06 3.9-6.23 7.69-9.46 11.4-4.18 4.87-8.14 9.88-12 15-0.496 0.654-0.992 1.31-1.5 1.98-0.708 0.949-0.708 0.949-1.43 1.92-0.412 0.551-0.824 1.1-1.25 1.67-1.25 1.86-2.36 3.74-3.47 5.69-0.632 1.11-1.26 2.23-1.91 3.37 1.85-0.00277 1.85-0.00277 3.74-0.00559 29.3-0.0433 58.6-0.0763 87.8-0.0965 3.6-0.0025 7.2-0.00509 10.8-0.00773 1.08-7.87e-4 1.08-7.87e-4 2.17-0.00159 11.6-0.00871 23.2-0.0245 34.9-0.0429 11.9-0.0187 23.8-0.0298 35.7-0.0339 6.7-0.0025 13.4-0.00853 20.1-0.0233 6.3-0.0135 12.6-0.0178 18.9-0.0148 2.32-5.52e-4 4.63-0.00456 6.95-0.0122 3.15-0.00989 6.3-0.00758 9.46-0.0021 1.39-0.00874 1.39-0.00874 2.8-0.0177 0.842 0.00398 1.68 0.00796 2.55 0.0121 0.728-7.59e-4 1.46-0.00152 2.21-0.0023 1.91 0.248 1.91 0.248 4.91 2.25 0.377 3 0.377 3 0.38 6.95 0.00466 0.727 0.00932 1.45 0.0141 2.2 0.012 2.46 0.00252 4.92-0.00676 7.39 0.00417 1.77 0.00964 3.55 0.0163 5.32 0.0145 4.89 0.0102 9.78 0.00283 14.7-0.00471 5.27 0.00776 10.5 0.018 15.8 0.0172 10.3 0.018 20.7 0.0128 31-0.00403 8.39-0.00261 16.8 0.00275 25.2 7.48e-4 1.19 0.0015 2.38 0.00227 3.61 0.00153 2.42 0.00307 4.84 0.00461 7.27 0.0137 22.7 0.00827 45.5-0.00319 68.2-0.00993 20.8 0.00301 41.6 0.0269 62.5 0.0244 21.4 0.034 42.7 0.0273 64.1-0.0035 12-0.00121 24 0.0163 36 0.0147 10.2 0.0154 20.4-0.00207 30.6-0.00855 5.22-0.0106 10.4 0.00465 15.6 0.0137 4.77 0.00922 9.54-0.0102 14.3-0.00379 1.73-7.43e-4 3.46 0.00961 5.19 0.013 2.34 0.00172 4.68-0.016 7.02-1.07e-4 1.3-2.15e-4 2.61-3.25e-4 3.95-0.5 3.13-0.5 3.13-2.19 4.8-2.83 1.62-4.59 1.7-7.84 1.7-1.13 0.00674-2.27 0.0135-3.44 0.0204-1.25-0.00788-2.5-0.0158-3.78-0.0239-1.34 0.00222-2.69 0.00575-4.03 0.0105-3.71 0.00923-7.42-3.41e-4 -11.1-0.0128-4.03-0.0103-8.06-0.00319-12.1 0.00173-7.07 0.00623-14.1 0.00127-21.2-0.0109-10.5-0.0181-21-0.019-31.5-0.0164-17.7 0.00395-35.4-0.0061-53-0.0241-17.5-0.0177-35-0.0293-52.5-0.0326-1.63-3.09e-4 -1.63-3.09e-4 -3.3-6.25e-4 -5.53-0.00101-11.1-0.00192-16.6-0.00278-39.2-0.00631-78.3-0.0265-117-0.0549-38-0.0275-76.1-0.0488-114-0.0615-1.17-3.95e-4 -2.34-7.89e-4 -3.55-0.0012-11.8-0.00396-23.5-0.00778-35.3-0.0115-24-0.00761-48-0.0161-71.9-0.0251-1.1-4.12e-4 -2.21-8.24e-4 -3.34-0.00125-73.7-0.0276-147-0.0751-221-0.126 0.956-1.28 1.91-2.56 2.87-3.84 0.533-0.712 1.07-1.42 1.61-2.16 1.8-2.38 3.67-4.7 5.58-7.01 2.69-3.26 5.36-6.52 8.02-9.8 5.18-6.41 10.4-12.8 15.7-19.1 3.74-4.39 7.39-8.83 11-13.3 7.26-9.11 14.6-18.1 22.2-27 3.26-3.83 6.38-7.76 9.46-11.7 4.25-5.48 8.68-10.8 13.2-16 5.39-6.23 10.6-12.6 15.7-19 0.782-0.975 1.56-1.95 2.37-2.95 0.696-0.875 1.39-1.75 2.11-2.65 3.03-3.42 5.78-5.96 10.1-7.41 2.26-0.104 4.52-0.147 6.78-0.158 1.05-0.00741 1.05-0.00741 2.12-0.015 2.36-0.0154 4.73-0.0238 7.09-0.0321 1.71-0.0096 3.42-0.0196 5.13-0.03 4.74-0.0274 9.48-0.0483 14.2-0.068 4.11-0.0177 8.22-0.0389 12.3-0.0599 12.5-0.0641 25.1-0.118 37.6-0.169 6.02-0.0247 12-0.0511 18.1-0.078 85.4-0.382 171-0.466 322-0.441 0.748 2.51e-4 1.5 5.03e-4 2.27 7.61e-4 30.8 0.0104 61.6 0.0314 92.5 0.0503v-154h-394c0-5.07 2.08-6.83 5.31-10.4 1.11-1.25 2.22-2.51 3.33-3.77 0.564-0.64 1.13-1.28 1.71-1.94 2.51-2.91 4.86-5.94 7.21-8.98 3.54-4.57 7.17-9.04 10.9-13.4 3.96-4.63 7.8-9.33 11.6-14.1 0.465-0.592 0.931-1.18 1.41-1.79 1.94-2.48 3.78-4.96 5.53-7.58h2c0.251-0.562 0.503-1.12 0.762-1.7 1.43-2.65 3.12-4.74 5.05-7.05l2.44-2.94c0.441-0.53 0.882-1.06 1.34-1.61 2.58-3.11 5.12-6.25 7.66-9.39 1.12-1.38 2.23-2.75 3.35-4.12 2.25-2.77 4.49-5.54 6.73-8.31 5.03-6.22 10.1-12.4 15.3-18.5 4.15-4.86 8.12-9.83 12-14.9 5.37-6.88 10.9-13.6 16.5-20.3 3.05-3.69 6.09-7.38 9.13-11.1l1.79-2.17c4.65-5.64 9.28-11.3 13.9-17 0.483-0.591 0.966-1.18 1.46-1.79 5.85-7.16 11.7-14.3 17.3-21.6 3.61-4.64 7.36-9.09 11.3-13.4 2.63-2.97 5.08-6.07 7.55-9.18 2.9-3.64 5.83-7.26 8.77-10.9 0.565-0.696 1.13-1.39 1.71-2.11 3.82-4.7 7.65-9.39 11.5-14.1 2.31-2.82 4.6-5.65 6.9-8.48 6.93-8.55 13.9-17 20.9-25.5 7.89-9.58 15.7-19.2 23.5-28.9 10.2-12.6 20.5-25.2 30.8-37.7 6.92-8.4 13.8-16.8 20.7-25.3 6.23-7.68 12.5-15.3 18.8-23 5.53-6.68 11-13.4 16.3-20.2 4.21-5.42 8.61-10.7 13.1-15.8 3.46-4 6.81-8.08 10.1-12.2 2.76-3.47 5.56-6.92 8.36-10.4 0.556-0.684 1.11-1.37 1.69-2.07 1.14-1.4 2.28-2.81 3.43-4.21 1.65-2.03 3.29-4.05 4.94-6.08 6.82-8.4 13.7-16.8 20.6-25.1 6.84-8.29 13.6-16.6 20.4-25 4.59-5.65 9.19-11.3 13.8-16.9 0.679-0.831 1.36-1.66 2.06-2.52 3.44-4.21 6.88-8.41 10.3-12.6 5.52-6.69 11-13.4 16.4-20.2 2.96-3.68 5.98-7.31 8.99-11 4.36-5.28 8.67-10.6 12.9-16 4.01-5.16 8.16-10.2 12.4-15.1 2.7-3.16 5.33-6.36 7.91-9.61 3.03-3.82 6.15-7.55 9.31-11.2 4.92-5.76 9.63-11.7 14.3-17.7 2.12-2.72 4.25-5.41 6.41-8.09z"
              fill="#000100" />
            <path transform="translate(814 65.8)"
              d="m0 0c0.772-0.00171 1.54-0.00342 2.34-0.00518 2.58-0.00329 5.17 0.0077 7.75 0.0186 1.85 5.64e-4 3.71 2.47e-4 5.56-8.85e-4 5.03-5.74e-4 10.1 0.0112 15.1 0.0251 5.26 0.0125 10.5 0.0137 15.8 0.0161 9.95 0.00622 19.9 0.0226 29.9 0.0427 11.3 0.0224 22.7 0.0334 34 0.0434 23.3 0.0209 46.6 0.0561 69.9 0.101 0.611 1.85 0.611 1.85 1 4-1.77 2.41-1.77 2.41-4.38 5.06-0.94 0.982-1.88 1.97-2.81 2.95-0.476 0.498-0.951 0.996-1.44 1.51-2.02 2.18-3.88 4.47-5.75 6.79-3.47 4.3-7.02 8.51-10.6 12.7-3.54 4.1-7.03 8.23-10.4 12.4-4.14 5.1-8.44 10.1-12.8 15-3.92 4.51-7.73 9.1-11.5 13.7-2.72 3.31-5.51 6.56-8.31 9.81-3.55 4.12-7.07 8.27-10.5 12.5-4.39 5.4-8.92 10.7-13.5 16-4.26 4.95-8.46 9.94-12.7 14.9-1.39 1.65-2.79 3.29-4.18 4.93-4.23 4.98-8.44 9.98-12.6 15.1-4.17 5.12-8.49 10.1-12.8 15.1-3.92 4.51-7.73 9.1-11.5 13.7-3.68 4.48-7.48 8.86-11.3 13.3-4.26 4.95-8.46 9.94-12.7 14.9-1.39 1.65-2.79 3.29-4.18 4.93-4.25 5.01-8.48 10-12.6 15.1-4.41 5.42-8.96 10.7-13.5 16-6.25 7.26-12.4 14.6-18.5 22-4.41 5.42-8.96 10.7-13.5 16-6.23 7.24-12.4 14.5-18.4 21.9-3.52 4.33-7.14 8.55-10.8 12.8-5.33 6.11-10.5 12.3-15.6 18.6-4.26 5.2-8.6 10.3-13 15.4-2.93 3.4-5.8 6.84-8.62 10.3-4.1 5.05-8.35 9.96-12.6 14.9-6.89 7.92-13.7 15.9-20.3 24.1-4.17 5.12-8.49 10.1-12.8 15.1-3.92 4.51-7.73 9.1-11.5 13.7-2.72 3.31-5.51 6.56-8.31 9.81-3.55 4.12-7.07 8.27-10.5 12.5-4.39 5.4-8.91 10.7-13.4 15.9-6.25 7.26-12.4 14.6-18.5 22-4.41 5.42-8.96 10.7-13.5 16-6.23 7.24-12.4 14.5-18.4 21.9-4.17 5.12-8.49 10.1-12.8 15.1-3.92 4.51-7.73 9.1-11.5 13.7-3.68 4.48-7.48 8.86-11.3 13.3-4.26 4.95-8.46 9.94-12.7 14.9-1.39 1.65-2.79 3.29-4.18 4.93-4.25 5.01-8.48 10-12.6 15.1-4.41 5.42-8.96 10.7-13.5 16-4.26 4.95-8.46 9.94-12.7 14.9-1.39 1.65-2.79 3.29-4.18 4.93-4.25 5.01-8.48 10-12.6 15.1-4.41 5.42-8.96 10.7-13.5 16-6.25 7.26-12.4 14.6-18.5 22-4.42 5.42-8.96 10.7-13.5 16-3.32 3.86-6.61 7.75-9.89 11.6-2.91 3.44-5.84 6.87-8.78 10.3-4.52 5.25-8.95 10.6-13.2 16-3.13 3.87-6.38 7.62-9.63 11.4-3.03 3.52-6.01 7.07-8.93 10.7-4.1 5.05-8.35 9.96-12.6 14.9-6.89 7.92-13.7 15.9-20.3 24.1-4.17 5.12-8.49 10.1-12.8 15.1-3.92 4.51-7.73 9.1-11.5 13.7-2.72 3.31-5.51 6.56-8.31 9.81-3.55 4.12-7.07 8.27-10.5 12.5-4.39 5.4-8.91 10.7-13.4 15.9-6.25 7.26-12.4 14.6-18.5 22-3.91 4.81-7.93 9.52-12 14.2-3.49 4.06-6.96 8.13-10.4 12.2-4.01 4.75-8.06 9.47-12.2 14.1-0.66-0.33-1.32-0.66-2-1-0.112-88.7-0.224-177-0.328-266-0.00155-1.31-0.0031-2.62-0.00469-3.98-0.0328-27.8-0.0654-55.6-0.0978-83.5-0.0163-14-0.0326-28-0.0489-41.9-0.00246-2.11-0.00493-4.22-0.00739-6.32-0.0379-32.5-0.0767-65-0.118-97.4-8.87e-4 -0.699-0.00177-1.4-0.00269-2.12-0.0143-11.3-0.0287-22.5-0.0431-33.8-0.0414-32.4-0.0824-64.9-0.12-97.3-7.69e-4 -0.666-0.00154-1.33-0.00233-2.02-0.0161-14-0.032-27.9-0.0476-41.9-0.00732-6.54-0.0147-13.1-0.022-19.6-0.00145-1.29-0.0029-2.58-0.0044-3.9-0.0235-20.8-0.0505-41.5-0.0787-62.3-0.0283-20.9-0.053-41.7-0.0739-62.6-0.0126-12.4-0.028-24.8-0.0473-37.2-0.0126-8.27-0.0217-16.5-0.0277-24.8-0.00355-4.72-0.00874-9.45-0.0183-14.2-0.00862-4.29-0.0127-8.58-0.0131-12.9-9.44e-4 -1.55-0.00361-3.1-0.0081-4.65-0.00581-2.09-0.00557-4.18-0.00369-6.27-0.0014-1.16-0.00281-2.32-0.00425-3.52 0.122-2.57 0.122-2.57 1.12-3.57h150v525c4.95-4.33 9.56-8.43 13.9-13.2 0.512-0.56 1.02-1.12 1.55-1.7 3.9-4.29 7.6-8.72 11.2-13.2 2.55-3.14 5.15-6.23 7.78-9.31 3.35-3.95 6.67-7.92 9.94-11.9 3.96-4.86 8.03-9.62 12.1-14.4 3.03-3.52 6.01-7.08 8.94-10.7 3.93-4.85 7.98-9.58 12.1-14.3 3.03-3.52 6.01-7.08 8.94-10.7 3.33-4.1 6.74-8.13 10.2-12.1 4.51-5.23 8.93-10.5 13.3-15.9 4.86-5.94 9.8-11.8 14.8-17.6 3.71-4.31 7.33-8.69 10.9-13.1 2.56-3.12 5.16-6.2 7.78-9.28 4.11-4.84 8.15-9.73 12.2-14.7 3.22-3.91 6.5-7.77 9.8-11.6 2.54-2.94 2.54-2.94 4.54-6.24h2c0.22-0.53 0.441-1.06 0.668-1.61 1.81-3.25 4.21-5.92 6.64-8.71 3.08-3.57 6.09-7.1 8.75-11 0.639-0.887 1.28-1.77 1.94-2.69h2c0.224-0.534 0.449-1.07 0.68-1.62 1.76-3.18 4.07-5.78 6.45-8.51 1-1.17 2.01-2.34 3.01-3.51 0.492-0.574 0.983-1.15 1.49-1.74 1.82-2.15 3.57-4.35 5.31-6.56 3.75-4.74 7.69-9.31 11.6-13.9 3.56-4.13 6.99-8.34 10.4-12.6 2.91-3.61 5.91-7.14 8.92-10.7 2.92-3.43 5.79-6.89 8.64-10.4 3.75-4.61 7.57-9.14 11.4-13.7 2.88-3.39 5.72-6.82 8.52-10.3 3.96-4.86 8.03-9.62 12.1-14.4 3.03-3.52 6.01-7.08 8.94-10.7 3.43-4.23 6.95-8.38 10.5-12.5 4.32-5.02 8.55-10.1 12.7-15.2 4.82-5.88 9.76-11.6 14.7-17.4 4.72-5.55 9.42-11.1 14-16.8 3.96-4.86 8.03-9.62 12.1-14.4 3.8-4.42 7.5-8.9 11.2-13.4 4.82-5.88 9.77-11.7 14.7-17.5 6.85-8.05 6.85-8.05 13.5-16.3 3.75-4.74 7.69-9.31 11.6-13.9 2.88-3.34 5.69-6.71 8.42-10.2 3.72-4.72 7.63-9.26 11.6-13.8 3.03-3.52 5.96-7.09 8.81-10.8 6.35-8.01 11.9-11.8 22.4-11.7z"
              fill="#000100" />
            <path transform="translate(1213 65.9)"
              d="m0 0c0.712-0.00156 1.42-0.00312 2.16-0.00473 2.39-0.00399 4.77-8.28e-4 7.16 0.00232 1.71-0.00136 3.42-0.00314 5.14-0.00531 4.65-0.00456 9.3-0.00279 14 3.79e-4 4.87 0.00253 9.74 1.84e-4 14.6-0.00139 8.18-0.00182 16.4 5.8e-4 24.5 0.00534 9.45 0.00544 18.9 0.00368 28.3-0.00183 8.12-0.00454 16.2-0.00518 24.3-0.00256 4.85 0.00156 9.69 0.00177 14.5-0.00154 4.56-0.0029 9.12-8.7e-4 13.7 0.00489 1.67 0.00132 3.34 9.5e-4 5.01-0.00126 2.29-0.00275 4.57 7.15e-4 6.86 0.00568 1.28 3.77e-4 2.56 7.54e-4 3.87 0.00114 3.97 0.135 7.77 0.577 11.7 1.13-1.32 3.73-2.92 6.45-5.44 9.5-1.07 1.31-1.07 1.31-2.16 2.64-3.98 4.75-7.97 9.48-12 14.2-1.39 1.63-2.77 3.26-4.15 4.9-4.77 5.66-9.57 11.3-14.4 16.9-3.49 4.06-6.94 8.15-10.3 12.3-4.1 5.05-8.35 9.96-12.6 14.9-6.91 7.95-13.7 16-20.4 24.1-3.96 4.86-8.03 9.62-12.1 14.4-3.8 4.42-7.51 8.91-11.2 13.4-2.45 2.99-4.94 5.94-7.45 8.88-4.3 5.06-8.54 10.2-12.8 15.3-4.91 5.98-9.89 11.9-14.9 17.7-3.45 4.01-6.78 8.11-10.1 12.3-2.91 3.61-5.91 7.14-8.92 10.7-2.92 3.43-5.79 6.89-8.64 10.4-3.75 4.61-7.57 9.14-11.4 13.7-2.88 3.39-5.72 6.82-8.52 10.3-3.47 4.27-7.03 8.46-10.6 12.6-3.39 3.93-6.72 7.87-9.94 11.9-3.71 4.7-7.6 9.23-11.5 13.8-3.05 3.54-6.05 7.11-8.99 10.7-3.93 4.85-7.98 9.58-12.1 14.3-3.03 3.52-6.01 7.08-8.94 10.7-3.93 4.85-7.98 9.58-12.1 14.3-3.03 3.52-6.01 7.08-8.94 10.7-3.43 4.23-6.95 8.38-10.5 12.5-4.32 5.01-8.55 10.1-12.7 15.2-3.02 3.68-6.11 7.31-9.19 10.9-2.88 3.39-5.72 6.82-8.52 10.3-3.96 4.86-8.03 9.62-12.1 14.4-3.03 3.52-6.01 7.08-8.94 10.7-3.43 4.23-6.95 8.38-10.5 12.5-4.32 5.01-8.55 10.1-12.7 15.2-2.56 3.12-5.16 6.2-7.78 9.28-3.37 3.97-6.71 7.96-10 12-3.75 4.6-7.57 9.14-11.4 13.7-2.9 3.42-5.76 6.86-8.59 10.3-3.75 4.6-7.57 9.14-11.4 13.7-2.9 3.42-5.76 6.86-8.59 10.3-3.29 4.04-6.63 8.03-10 12-4.05 4.77-8.04 9.58-12 14.4-3.12 3.82-6.25 7.64-9.38 11.4-0.602 0.732-1.2 1.46-1.82 2.22-3.62 4.4-7.29 8.76-11 13.1-4.26 4.99-8.31 10.1-12.3 15.3-3.37 4.31-6.96 8.36-10.7 12.4-3.27 3.71-6.27 7.61-9.3 11.5-3.21 4.12-6.56 8.05-10.1 11.9-2.94 3.3-5.69 6.75-8.47 10.2-2.73 3.32-5.54 6.57-8.35 9.82-4.06 4.69-7.96 9.47-11.8 14.4-4.11 5.32-8.48 10.3-13.1 15.2-2.87 3.17-5.49 6.48-8.13 9.84-2.64 3.28-5.38 6.47-8.13 9.66-4.34 5.04-8.6 10.1-12.8 15.3-4.82 5.88-9.76 11.6-14.7 17.4-4.72 5.55-9.42 11.1-14 16.8-3.96 4.86-8.03 9.62-12.1 14.4-3.8 4.41-7.5 8.9-11.2 13.4-2.56 3.12-5.16 6.2-7.78 9.28-3.37 3.97-6.71 7.96-10 12-3.75 4.6-7.57 9.14-11.4 13.7-3.64 4.3-7.21 8.65-10.8 13-2.59 3.15-5.23 6.27-7.88 9.38-3.19 3.75-6.33 7.52-9.38 11.4-3.75 4.74-7.69 9.31-11.6 13.9-3.56 4.13-6.99 8.34-10.4 12.6-2.91 3.61-5.91 7.14-8.92 10.7-2.92 3.43-5.79 6.89-8.64 10.4-3.75 4.6-7.57 9.14-11.4 13.7-2.9 3.42-5.76 6.86-8.59 10.3-3.75 4.61-7.57 9.14-11.4 13.7-2.88 3.39-5.72 6.82-8.52 10.3-3.96 4.86-8.03 9.62-12.1 14.4-3.8 4.41-7.5 8.9-11.2 13.4-3.02 3.69-6.11 7.31-9.2 10.9-2.86 3.37-5.67 6.77-8.46 10.2-4.17 5.12-8.49 10.1-12.8 15.1-3.16 3.63-6.27 7.3-9.3 11-3.58 4.42-7.27 8.72-11 13-4.5 5.17-8.91 10.4-13.2 15.7-3.19 3.89-6.45 7.72-9.73 11.5-2.54 2.94-2.54 2.94-4.54 6.24h-2c-0.226 0.535-0.451 1.07-0.684 1.62-1.74 3.15-4.03 5.74-6.38 8.44-1 1.17-2 2.34-3 3.5-0.498 0.58-0.995 1.16-1.51 1.76-2.01 2.36-3.97 4.77-5.93 7.18-3.75 4.6-7.57 9.14-11.4 13.7-3.64 4.3-7.21 8.65-10.8 13-2.59 3.15-5.23 6.27-7.88 9.38-3.87 4.55-7.64 9.17-11.4 13.9-2.41 2.99-4.9 5.91-7.39 8.83-3.8 4.46-7.48 8.99-11.1 13.6-4.4 5.68-9.04 11.1-13.8 16.5-3.68 4.21-7.18 8.51-10.6 12.9-3.89 5.03-7.94 9.83-12.3 14.5-1.79 1.98-3.41 4.02-5.05 6.12-3.95 4.59-8.9 5.87-14.8 6.43-1.36 0.0124-2.73 0.00882-4.09-0.00838-0.758 0.00256-1.52 0.00513-2.3 0.00777-2.52 0.00491-5.04-0.0115-7.55-0.028-1.81-8.47e-4 -3.63-3.7e-4 -5.44 0.00133-4.91 8.59e-4 -9.82-0.0167-14.7-0.0377-5.14-0.0188-10.3-0.0205-15.4-0.0241-9.72-0.00931-19.4-0.0339-29.2-0.064-11.1-0.0336-22.1-0.05-33.2-0.0651-22.8-0.0313-45.5-0.0841-68.3-0.151 0.439-1.43 0.889-2.86 1.34-4.28 0.374-1.19 0.374-1.19 0.755-2.41 1.43-3.65 3.76-6.22 6.4-9.06 1.08-1.21 2.16-2.42 3.24-3.63 0.817-0.903 0.817-0.903 1.65-1.82 2.49-2.78 4.9-5.63 7.3-8.48 0.455-0.538 0.91-1.08 1.38-1.63 2.83-3.35 5.61-6.72 8.37-10.1 3.96-4.86 8.03-9.62 12.1-14.4 3.8-4.41 7.5-8.9 11.2-13.4 2.56-3.12 5.16-6.2 7.78-9.28 3.37-3.97 6.71-7.96 10-12 3.75-4.61 7.57-9.14 11.4-13.7 2.88-3.39 5.72-6.82 8.52-10.3 4.41-5.42 8.96-10.7 13.5-16 6.25-7.26 12.4-14.6 18.5-22 3.96-4.86 8.03-9.62 12.1-14.4 3.03-3.52 6.01-7.08 8.94-10.7 3.93-4.85 7.98-9.58 12.1-14.3 3.03-3.52 6.01-7.08 8.94-10.7 3.93-4.85 7.98-9.58 12.1-14.3 3.03-3.52 6.01-7.08 8.94-10.7 3.93-4.85 7.98-9.58 12.1-14.3 3.03-3.52 6.01-7.08 8.94-10.7 4.39-5.4 8.91-10.7 13.4-15.9 6.25-7.26 12.4-14.6 18.5-22 3.96-4.86 8.03-9.62 12.1-14.4 3.03-3.52 6.01-7.08 8.94-10.7 3.43-4.23 6.95-8.38 10.5-12.5 4.33-5.02 8.56-10.1 12.7-15.2 2.45-2.99 4.94-5.94 7.45-8.88 4.32-5.08 8.58-10.2 12.8-15.4 4.68-5.7 9.39-11.4 14.2-17 3.56-4.19 7.05-8.45 10.5-12.7 3.04-3.69 6.13-7.33 9.23-11 3.65-4.3 7.22-8.66 10.8-13 2.53-3.07 5.1-6.09 7.68-9.11 3.87-4.54 7.6-9.16 11.2-13.9 3.89-5.02 7.96-9.78 12.3-14.5 2.84-3.16 5.46-6.47 8.09-9.8 5.82-7.37 11.9-14.6 17.9-21.7 2.88-3.39 5.72-6.82 8.52-10.3 3.47-4.27 7.03-8.46 10.6-12.6 3.39-3.93 6.72-7.87 9.94-11.9 3.71-4.7 7.6-9.23 11.5-13.8 3.05-3.54 6.05-7.11 8.99-10.7 3.93-4.85 7.98-9.58 12.1-14.3 3.03-3.52 6.01-7.08 8.94-10.7 4.39-5.4 8.91-10.7 13.4-15.9 14.7-17.1 14.7-17.1 28.6-35 0.698-0.783 0.698-0.783 1.41-1.58h2c0.226-0.535 0.451-1.07 0.684-1.62 1.74-3.15 4.03-5.74 6.38-8.44 1-1.17 2.01-2.34 3.01-3.51 0.498-0.58 0.996-1.16 1.51-1.76 1.99-2.34 3.93-4.72 5.86-7.11 3.96-4.86 8.03-9.62 12.1-14.4 3.8-4.41 7.5-8.9 11.2-13.4 2.56-3.12 5.16-6.2 7.78-9.28 3.37-3.97 6.71-7.96 10-12 3.75-4.6 7.57-9.14 11.4-13.7 2.9-3.42 5.76-6.86 8.59-10.3 3.75-4.6 7.57-9.14 11.4-13.7 2.9-3.42 5.76-6.86 8.59-10.3 3.75-4.6 7.57-9.14 11.4-13.7 2.9-3.42 5.76-6.86 8.59-10.3 3.75-4.6 7.57-9.14 11.4-13.7 2.9-3.42 5.76-6.86 8.59-10.3 3.75-4.6 7.57-9.14 11.4-13.7 2.9-3.42 5.76-6.86 8.59-10.3 3.75-4.6 7.57-9.14 11.4-13.7 2.9-3.42 5.76-6.86 8.59-10.3 5.54-6.8 11.2-13.5 16.9-20.2 5.49-6.46 10.9-12.9 16.3-19.5 3.04-3.69 6.13-7.33 9.23-11 2.9-3.42 5.76-6.86 8.59-10.3 3.75-4.6 7.57-9.14 11.4-13.7 2.9-3.42 5.76-6.86 8.59-10.3 3.75-4.6 7.57-9.14 11.4-13.7 2.9-3.42 5.76-6.86 8.59-10.3 3.75-4.61 7.57-9.14 11.4-13.7 2.88-3.39 5.72-6.82 8.52-10.3 3.96-4.86 8.03-9.62 12.1-14.4 3.8-4.41 7.5-8.9 11.2-13.4 2.56-3.12 5.16-6.2 7.78-9.28 4.05-4.77 8.05-9.58 12-14.4 8.02-9.84 16.1-19.6 24.4-29.2 3.45-4.01 6.78-8.11 10.1-12.3 2.91-3.61 5.91-7.14 8.92-10.7 2.9-3.41 5.75-6.85 8.57-10.3 3.47-4.27 7.03-8.46 10.6-12.6 3.39-3.93 6.72-7.87 9.94-11.9 3.71-4.7 7.6-9.22 11.5-13.8 3.81-4.43 7.53-8.93 11.2-13.5 2.56-3.12 5.16-6.2 7.78-9.28 3.39-3.99 6.75-8 10.1-12.1 0.722-0.879 1.44-1.76 2.19-2.66 1.61-1.98 3.19-3.97 4.75-5.98 7.66-9.72 14.1-13.9 26.6-13.9z"
              fill="#000100" />
          </svg>
          <div className="name-container">
            <div className="logo-name">VIS GROUP</div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default HomeNew;
